import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { AddButton, DBCheckBox, DBDropDown, DBIntRangeField, DBTextArea, StatusWarning } from '_components';
import styles from './Common.module.css'
import { ModalityTimedEntry, ModalityUntimedEntry, OtherUntimedEntry } from 'PatientCareCenter/Note/Plan';
import { getPocTextLong } from '_helpers';

class PatientCareCenterNotePlanBody extends React.Component {

    constructor(props) {
        super(props);
        this.pnPocClicked = this.pnPocClicked.bind(this);
    }

    componentDidMount() {
        if (this.props.requireNewPoc && !this.props.plan.PLNEWPOC) {
            this.props.updateBitField(this.props.noteId, 'PTPLAN', 'PLNO', this.props.plno, 'PLNEWPOC', true);
        }
    }


    evalClicked(val) {
        if (this.props.plan.PLEVALONLY === true && val === true) {
            this.props.clearField(this.props.noteId, 'PTPLAN', 'PLNO', this.props.plno, 'PLEVALONLY');
        }
    }

    evalOnlyClicked(val) {
        if (this.props.plan.PLEVAL === true && val === true) {
            this.props.clearField(this.props.noteId, 'PTPLAN', 'PLNO', this.props.plno, 'PLEVAL');
        }
        if (val === true) {
            // Default the duration/frequency here
            if (this.props.plan.PLPOCTIMESMAX !== 1) {
                this.props.updateIntField(this.props.noteId, 'PTPLAN', 'PLNO', this.props.plno, 'PLPOCTIMESMAX', 1);
            }
            if (this.props.plan.PLPOCTIMETYPE !== 1) {
                this.props.updateIntField(this.props.noteId, 'PTPLAN', 'PLNO', this.props.plno, 'PLPOCTIMETYPE', 1);
            }
            if (this.props.plan.PLPOCDURMAX !== 1) {
                this.props.updateIntField(this.props.noteId, 'PTPLAN', 'PLNO', this.props.plno, 'PLPOCDURMAX', 1);
            }
            if (this.props.plan.PLPOCDURTYPE !== 1) {
                this.props.updateIntField(this.props.noteId, 'PTPLAN', 'PLNO', this.props.plno, 'PLPOCDURTYPE', 1);
            }
        }
    }

    pnPocClicked(field, val) {
        if (field === 'new' && val === true && this.props.plan.PLCONTINUE) {
            this.props.clearField(this.props.noteId, 'PTPLAN', 'PLNO', this.props.plno, 'PLCONTINUE');
        }
        else if (field === 'continue' && val === true &&
            (this.props.plan.PLNEWPOC ||
                this.props.plan.PLPOCTIMESMIN ||
                this.props.plan.PLPOCTIMESMAX ||
                this.props.plan.PLPOCTIMETYPE ||
                this.props.plan.PLPOCDURMIN ||
                this.props.plan.PLPOCDURMAX ||
                this.props.plan.PLPOCDURTYPE ||
                this.props.plan.PLPOCDETAILS)) {

            let fields = ['PLNEWPOC',
                'PLPOCTIMESMIN',
                'PLPOCTIMESMAX',
                'PLPOCTIMETYPE',
                'PLPOCDURMIN',
                'PLPOCDURMAX',
                'PLPOCDURTYPE',
                'PLPOCDETAILS'
            ];
            this.props.clearFields(this.props.noteId, 'PTPLAN', 'PLNO', this.props.plno, fields);
        }

    }

    addModTimed() {
        this.props.addChildRow(this.props.noteId, 'PTPLANTIMEDMODALITIES', 'TM', 'TMPLNO', this.props.plno);
    }

    addModUntimed() {
        this.props.addChildRow(this.props.noteId, 'PTPLANUNTIMEDMODALITIES', 'UM', 'UMPLNO', this.props.plno);
    }

    addOther() {
        this.props.addChildRow(this.props.noteId, 'PTPLANUNTIMEDOTHER', 'UO', 'UOPLNO', this.props.plno);
    }

    render() {
        return (
            <div>
                {this.props.isSpeech ?
                    <div>

                        <div className={styles.row}>
                            <span className={styles.label}>Eval</span>
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='PTPLAN'
                                entityKeyColumn='PLNO'
                                entityKeyValue={this.props.plno}
                                field='PLEVALONLY'
                                className={styles.plan_checkbox}
                                label='Eval Only'
                                onClick={(val) => this.evalOnlyClicked(val)}
                            />
                        </div>

                        <div className={styles.row}>
                            <span className={styles.label} />
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='PTPLAN'
                                entityKeyColumn='PLNO'
                                entityKeyValue={this.props.plno}
                                field='PLSPFLUENCY'
                                className={styles.plan_checkbox}
                                label='Speech Fluency - Eval'
                            />
                        </div>

                        <div className={styles.row}>
                            <span className={styles.label} />
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='PTPLAN'
                                entityKeyColumn='PLNO'
                                entityKeyValue={this.props.plno}
                                field='PLSPSOUNDPROD'
                                className={styles.plan_checkbox}
                                label='Speech Sound Production - Eval'
                            />
                        </div>

                        <div className={styles.row}>
                            <span className={styles.label} />
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='PTPLAN'
                                entityKeyColumn='PLNO'
                                entityKeyValue={this.props.plno}
                                field='PLSPLANGCOMP'
                                className={styles.plan_checkbox}
                                label='ST Sound Prod/Lang Comp - Eval'
                            />
                        </div>

                        <div className={styles.row}>
                            <span className={styles.label} />
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='PTPLAN'
                                entityKeyColumn='PLNO'
                                entityKeyValue={this.props.plno}
                                field='PLSPVOICE'
                                className={styles.plan_checkbox}
                                label='Behavorial/Qual Voice - Eval'
                            />
                        </div>

                        <div className={styles.row}>
                            <span className={styles.label} />
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='PTPLAN'
                                entityKeyColumn='PLNO'
                                entityKeyValue={this.props.plno}
                                field='PLSPSWALLOWEVAL'
                                className={styles.plan_checkbox}
                                label='Swallowing - Eval'
                            />
                        </div>

                        <div className={styles.row}>
                            <span className={styles.label} />
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='PTPLAN'
                                entityKeyColumn='PLNO'
                                entityKeyValue={this.props.plno}
                                field='PLSPAUGDEVICE'
                                className={styles.plan_checkbox}
                                label='Augumentative Device - Eval'
                            />
                        </div>

                        <div className={styles.row}>
                            <span className={styles.label}>Treatment</span>
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='PTPLAN'
                                entityKeyColumn='PLNO'
                                entityKeyValue={this.props.plno}
                                field='PLSPLANGTREAT'
                                className={styles.plan_checkbox}
                                label='Speech/Language Treatment'
                            />
                        </div>

                        <div className={styles.row}>
                            <span className={styles.label} />
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='PTPLAN'
                                entityKeyColumn='PLNO'
                                entityKeyValue={this.props.plno}
                                field='PLSPSWALLOW'
                                className={styles.plan_checkbox}
                                label='Swallowing Treatment'
                            />
                        </div>

                        <div className={styles.row}>
                            <span className={styles.label} />
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='PTPLAN'
                                entityKeyColumn='PLNO'
                                entityKeyValue={this.props.plno}
                                field='PLSPGROUPTREAT'
                                className={styles.plan_checkbox}
                                label='Speech Group Treatment'
                            />
                        </div>

                        <div className={styles.padding_row} />
                        {patientAppearance({ ...this.props, pnPocClicked: this.pnPocClicked })}
                    </div> : (<>
                        <div className={styles.row}>
                            <span className={styles.label}>Attended/Untimed CPT Codes</span>
                            {this.props.noteType === 1 &&
                                <DBCheckBox
                                    noteId={this.props.noteId}
                                    entity='PTPLAN'
                                    entityKeyColumn='PLNO'
                                    entityKeyValue={this.props.plno}
                                    field='PLEVAL'
                                    className={styles.plan_checkbox}
                                    label='Evaluation'
                                    onClick={(val) => this.evalClicked(val)}
                                />
                            }
                            {(this.props.noteType === 3 || this.props.noteType === 5) &&
                                <DBCheckBox
                                    noteId={this.props.noteId}
                                    entity='PTPLAN'
                                    entityKeyColumn='PLNO'
                                    entityKeyValue={this.props.plno}
                                    field='PLREEVAL'
                                    className={styles.plan_checkbox}
                                    label='Re-Evaluation'
                                />
                            }
                        </div>
                        {this.props.noteType === 1 &&
                            <div className={styles.row}>
                                <span className={styles.label} />
                                <DBCheckBox
                                    noteId={this.props.noteId}
                                    entity='PTPLAN'
                                    entityKeyColumn='PLNO'
                                    entityKeyValue={this.props.plno}
                                    field='PLEVALONLY'
                                    className={styles.plan_checkbox}
                                    label='Eval Only'
                                    onClick={(val) => this.evalOnlyClicked(val)}
                                />
                            </div>
                        }
                        <div className={styles.row}>
                            <span className={styles.label}>Attended/Timed CPT Codes</span>
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='PTPLAN'
                                entityKeyColumn='PLNO'
                                entityKeyValue={this.props.plno}
                                field='PLTHERACT'
                                className={styles.plan_checkbox}
                                disabled={this.props.therActPerformed}
                                label='Therapeutic Activities'
                            />
                            {this.props.therActPerformed &&
                                <div className={styles.disabled_flag2}>
                                    <StatusWarning size='extra-small' title='This code is required in the plan based on the Activity Log' />
                                </div>
                            }
                        </div>
                        <div className={styles.row}>
                            <span className={styles.label} />
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='PTPLAN'
                                entityKeyColumn='PLNO'
                                entityKeyValue={this.props.plno}
                                field='PLSELFCARE'
                                className={styles.plan_checkbox}
                                disabled={this.props.selfCarePerformed}
                                label='Self-Care'
                            />
                            {this.props.selfCarePerformed &&
                                <div className={styles.disabled_flag2}>
                                    <StatusWarning size='extra-small' title='This code is required in the plan based on the Activity Log' />
                                </div>
                            }
                        </div>
                        <div className={styles.row}>
                            <span className={styles.label} />
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='PTPLAN'
                                entityKeyColumn='PLNO'
                                entityKeyValue={this.props.plno}
                                field='PLNEURO'
                                className={styles.plan_checkbox}
                                disabled={this.props.neuroPerformed}
                                label='Neuromuscular Re-Ed'
                            />
                            {this.props.neuroPerformed &&
                                <div className={styles.disabled_flag2}>
                                    <StatusWarning size='extra-small' title='This code is required in the plan based on the Activity Log' />
                                </div>
                            }
                        </div>
                        <div className={styles.row}>
                            <span className={styles.label} />
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='PTPLAN'
                                entityKeyColumn='PLNO'
                                entityKeyValue={this.props.plno}
                                field='PLTHEREX'
                                className={styles.plan_checkbox}
                                disabled={this.props.therExPerformed}
                                label='Therapeutic Exercises'
                            />
                            {this.props.therExPerformed &&
                                <div className={styles.disabled_flag2}>
                                    <StatusWarning size='extra-small' title='This code is required in the plan based on the Activity Log' />
                                </div>
                            }
                        </div>
                        <div className={styles.row}>
                            <span className={styles.label} />
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='PTPLAN'
                                entityKeyColumn='PLNO'
                                entityKeyValue={this.props.plno}
                                field='PLMANUAL'
                                className={styles.plan_checkbox}
                                disabled={this.props.manualPerformed}
                                label='Manual Therapy'
                            />
                            {this.props.manualPerformed &&
                                <div className={styles.disabled_flag2}>
                                    <StatusWarning size='extra-small' title='This code is required in the plan based on the Activity Log' />
                                </div>
                            }
                        </div>
                        <div className={styles.row}>
                            <span className={styles.label} />
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='PTPLAN'
                                entityKeyColumn='PLNO'
                                entityKeyValue={this.props.plno}
                                field='PLGAIT'
                                className={styles.plan_checkbox}
                                disabled={this.props.gaitPerformed}
                                label='Gait'
                            />
                            {this.props.gaitPerformed &&
                                <div className={styles.disabled_flag2}>
                                    <StatusWarning size='extra-small' title='This code is required in the plan based on the Activity Log' />
                                </div>
                            }
                        </div>
                        <div className={styles.row}>
                            <span className={styles.label} />
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='PTPLAN'
                                entityKeyColumn='PLNO'
                                entityKeyValue={this.props.plno}
                                field='PLAQUATICS'
                                className={styles.plan_checkbox}
                                disabled={this.props.aquaPerformed}
                                label='Aquatics'
                            />
                            {this.props.aquaPerformed &&
                                <div className={styles.disabled_flag2}>
                                    <StatusWarning size='extra-small' title='This code is required in the plan based on the Activity Log' />
                                </div>
                            }
                        </div>
                        <div className={styles.row}>
                            <span className={styles.label} />
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='PTPLAN'
                                entityKeyColumn='PLNO'
                                entityKeyValue={this.props.plno}
                                field='PLGROUP'
                                className={styles.plan_checkbox}
                                label='Group Therapy'
                            />
                        </div>
                        <div className={styles.row}>
                            <span className={styles.label} />
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='PTPLAN'
                                entityKeyColumn='PLNO'
                                entityKeyValue={this.props.plno}
                                field='PLPERFTEST'
                                className={styles.plan_checkbox}
                                disabled={this.props.physTestPerformed}
                                label='Physical Performance Test or Measurement'
                            />
                            {this.props.physTestPerformed &&
                                <div className={styles.disabled_flag2}>
                                    <StatusWarning size='extra-small' title='This code is required in the plan based on the Activity Log' />
                                </div>
                            }
                        </div>

                        {this.props.rtmAvailable &&
                            <div className={styles.row}>
                                <span className={styles.label} />
                                <DBCheckBox
                                    noteId={this.props.noteId}
                                    entity='PTPLAN'
                                    entityKeyColumn='PLNO'
                                    entityKeyValue={this.props.plno}
                                    field='PLRTM'
                                    className={styles.plan_checkbox}
                                    label='Remote Therapeutic Monitoring'
                                />
                            </div>
                        }
                        <div className={styles.row}>
                            <span className={styles.label}>Unattended/Timed Codes</span>
                            <span className={styles.sub_cat}>
                                <AddButton title='Add Timed Modality...' size='extra-small' onClick={() => this.addModTimed()} />
                                <span className={styles.sub_cat_label}>Modalities Timed</span>
                            </span>
                            <span className={styles.sub_cat_wrapper}>
                                {
                                    Object.keys(this.props.timedModalities)
                                        .map(key => {
                                            const result = this.props.timedModalities[key];
                                            return (
                                                <ModalityTimedEntry key={result.TMNO} id={result.TMNO} />
                                            )
                                        })
                                }
                            </span>
                        </div>
                        <div className={styles.row}>
                            <span className={styles.label}>Unattended/Untimed Codes</span>
                            <span className={styles.sub_cat}>
                                <AddButton title='Add Untimed Modality...' size='extra-small' onClick={() => this.addModUntimed()} />
                                <span className={styles.sub_cat_label}>Modalities Untimed</span>
                            </span>
                            <span className={styles.sub_cat_wrapper}>
                                {
                                    Object.keys(this.props.untimedModalities)
                                        .map(key => {
                                            const result = this.props.untimedModalities[key];
                                            return (
                                                <ModalityUntimedEntry key={result.UMNO} id={result.UMNO} />
                                            )
                                        })
                                }
                            </span>
                        </div>
                        <div className={styles.row}>
                            <span className={styles.label} />
                            <span className={styles.sub_cat}>
                                <AddButton title='Add Other...' size='extra-small' onClick={() => this.addOther()} />
                                <span className={styles.sub_cat_label}>Other</span>
                            </span>
                            <span className={styles.sub_cat_wrapper}>
                                {
                                    Object.keys(this.props.untimedOther)
                                        .map(key => {
                                            const result = this.props.untimedOther[key];
                                            return (
                                                <OtherUntimedEntry key={result.UONO} id={result.UONO} />
                                            )
                                        })
                                }
                            </span>
                        </div>
                        {this.props.isWc &&
                            <span>
                                <div className={styles.row}>
                                    <span className={styles.label}>Work Comp Codes</span>
                                    <DBCheckBox
                                        noteId={this.props.noteId}
                                        entity='PTPLAN'
                                        entityKeyColumn='PLNO'
                                        entityKeyValue={this.props.plno}
                                        field='PLFCE'
                                        className={styles.plan_checkbox}
                                        label='FCE/POET'
                                    />
                                </div>
                                <div className={styles.row}>
                                    <span className={styles.label} />
                                    <DBCheckBox
                                        noteId={this.props.noteId}
                                        entity='PTPLAN'
                                        entityKeyColumn='PLNO'
                                        entityKeyValue={this.props.plno}
                                        field='PLWORKHARD'
                                        className={styles.plan_checkbox}
                                        label='Work Hardening/Conditioning'
                                    />
                                </div>
                                <div className={styles.row}>
                                    <span className={styles.label} />
                                    <DBCheckBox
                                        noteId={this.props.noteId}
                                        entity='PTPLAN'
                                        entityKeyColumn='PLNO'
                                        entityKeyValue={this.props.plno}
                                        field='PLPHYSRECOND'
                                        className={styles.plan_checkbox}
                                        label='Physical Reconditioning'
                                    />
                                </div>
                                {/* DevOps 19725 - Removing based on input from Carrie <div className={styles.row}>
                                    <DBCheckBox
                                        noteId={this.props.noteId}
                                        entity='PTPLAN'
                                        entityKeyColumn='PLNO'
                                        entityKeyValue={this.props.plno}
                                        field='PLWCWORKPROG'
                                        className={styles.work_prog_checkbox}
                                        label=""
                                    />
                                    <label className={styles.work_prog_label}>Due to patient's job demands and time away from work, therapist will consider future work program if deemed appropriate by referring physician and care team.</label>
                                    <span className={styles.work_prog_spacer} />
                                </div> */}

                            </span>
                        }
                        <div className={styles.padding_row} />
                        {patientAppearance({ ...this.props, pnPocClicked: this.pnPocClicked })}
                        {this.props.rangeUsed &&
                            <div className={styles.row}>
                                <label className={styles.details}>Details:</label>
                                <DBTextArea
                                    noteId={this.props.noteId}
                                    entity='PTPLAN'
                                    entityKeyColumn='PLNO'
                                    entityKeyValue={this.props.plno}
                                    field='PLPOCDETAILS'
                                    className={styles.textarea}
                                />
                            </div>
                        }
                        {(this.props.noteType === 3 || this.props.noteType === 5) &&
                            <span>
                                {!this.props.requireNewPoc &&
                                    <div className={styles.row}>
                                        <DBCheckBox
                                            noteId={this.props.noteId}
                                            entity='PTPLAN'
                                            entityKeyColumn='PLNO'
                                            entityKeyValue={this.props.plno}
                                            field='PLCONTINUE'
                                            className={styles.new_poc}
                                            label='Continue with recommended plan of care.'
                                            onClick={(val) => this.pnPocClicked('continue', val)}
                                        />
                                        <label className={styles.poc_label}>{getPocTextLong(this.props.poc)}</label>
                                    </div>
                                }
                                <div className={styles.row}>
                                    <DBCheckBox
                                        noteId={this.props.noteId}
                                        entity='PTPLAN'
                                        entityKeyColumn='PLNO'
                                        entityKeyValue={this.props.plno}
                                        field='PLFOLLOWUP'
                                        className={styles.new_poc}
                                        label='Follow up with physician.'
                                    />
                                </div>
                            </span>
                        }
                    </>)}
            </div>
        );

        function patientAppearance(props) {
            return <div className={styles.row_not_full}>
                {props.noteType === 1 &&
                    <label className={styles.sentence_req}>Patient will be seen </label>}
                {(props.noteType === 3 || props.noteType === 5) &&
                    <DBCheckBox
                        noteId={props.noteId}
                        entity='PTPLAN'
                        entityKeyColumn='PLNO'
                        entityKeyValue={props.plno}
                        field='PLNEWPOC'
                        disabled={props.requireNewPoc}
                        className={props.requireNewPoc ? styles.new_poc_req : styles.new_poc}
                        label='Patient will be seen for'
                        onClick={(val) => props.pnPocClicked('new', val)} />}
                <DBIntRangeField
                    noteId={props.noteId}
                    entity='PTPLAN'
                    entityKeyColumn='PLNO'
                    entityKeyValue={props.plno}
                    min={1}
                    disabled={props.plan.PLEVALONLY || (props.noteType !== 1 && !props.plan.PLNEWPOC)}
                    fieldLower='PLPOCTIMESMIN'
                    fieldUpper='PLPOCTIMESMAX'
                    className={styles.poc_input} />
                <label className={props.noteType === 1 || props.requireNewPoc ? styles.sentence_req : styles.sentence}>time(s) per</label>
                <DBDropDown
                    className={styles.drop_down1}
                    noteId={props.noteId}
                    entity='PTPLAN'
                    entityKeyColumn='PLNO'
                    entityKeyValue={props.plno}
                    field='PLPOCTIMETYPE'
                    disabled={props.plan.PLEVALONLY || (props.noteType !== 1 && !props.plan.PLNEWPOC)}
                    masterEntity='PTMASTERPLANTIMES'
                    masterEntityKeyColumn='TXNO'
                    masterEntitySort='TXORDER'
                    masterEntityDisplay='TXNAME' />
                <label className={props.noteType === 1 || props.requireNewPoc ? styles.sentence_req : styles.sentence}>for</label>
                {props.isPeds && props.isMinEnabled &&
                    <>
                        <DBIntRangeField
                            noteId={props.noteId}
                            entity='PTPLAN'
                            entityKeyColumn='PLNO'
                            entityKeyValue={props.plno}
                            min={1}
                            disabled={props.plan.PLEVALONLY || (props.noteType !== 1 && !props.plan.PLNEWPOC)}
                            fieldLower='PLMINUTESMIN'
                            fieldUpper='PLMINUTESMAX'
                            className={styles.poc_input} />
                        <label className={props.noteType === 1 || props.requireNewPoc ? styles.sentence_req : styles.sentence}>minutes X</label>
                    </>}
                <DBIntRangeField
                    noteId={props.noteId}
                    entity='PTPLAN'
                    entityKeyColumn='PLNO'
                    entityKeyValue={props.plno}
                    min={1}
                    disabled={props.plan.PLEVALONLY || (props.noteType !== 1 && !props.plan.PLNEWPOC)}
                    fieldLower='PLPOCDURMIN'
                    fieldUpper='PLPOCDURMAX'
                    className={styles.poc_input} />
                <DBDropDown
                    className={styles.drop_down2}
                    noteId={props.noteId}
                    entity='PTPLAN'
                    entityKeyColumn='PLNO'
                    entityKeyValue={props.plno}
                    field='PLPOCDURTYPE'
                    disabled={props.plan.PLEVALONLY || (props.noteType !== 1 && !props.plan.PLNEWPOC)}
                    masterEntity='PTMASTERPLANDURATIONS'
                    masterEntityKeyColumn='DXNO'
                    masterEntitySort='DXORDER'
                    masterEntityDisplay='DXNAME' />
                <label className={props.noteType === 1 || props.requireNewPoc ? styles.sentence_req : styles.sentence}>.</label>
            </div>;
        }
    }

}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        clearFields: bindActionCreators(noteActions.clearFields, dispatch),
        updateIntField: bindActionCreators(noteActions.updateIntField, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
        addChildRow: bindActionCreators(noteActions.addChildRow, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let plno = parseInt(Object.keys(state.entities.notes.PTPLAN)
        .find(key => (state.entities.notes.PTPLAN[key].PLEVNO === pk && noteType === 1)
            || (state.entities.notes.PTPLAN[key].PLNTNO === pk && noteType !== 1)));
    let plan = state.entities.notes.PTPLAN[plno];
    let timedModalities = Object.keys(state.entities.notes.PTPLANTIMEDMODALITIES)
        .filter(key => state.entities.notes.PTPLANTIMEDMODALITIES[key].TMPLNO === plno)
        .sort((a, b) => state.entities.notes.PTPLANTIMEDMODALITIES[a].TMNO - state.entities.notes.PTPLANTIMEDMODALITIES[b].TMNO)
        .map(key => state.entities.notes.PTPLANTIMEDMODALITIES[key]);
    let untimedModalities = Object.keys(state.entities.notes.PTPLANUNTIMEDMODALITIES)
        .filter(key => state.entities.notes.PTPLANUNTIMEDMODALITIES[key].UMPLNO === plno)
        .sort((a, b) => state.entities.notes.PTPLANUNTIMEDMODALITIES[a].UMNO - state.entities.notes.PTPLANUNTIMEDMODALITIES[b].UMNO)
        .map(key => state.entities.notes.PTPLANUNTIMEDMODALITIES[key]);
    let untimedOther = Object.keys(state.entities.notes.PTPLANUNTIMEDOTHER)
        .filter(key => state.entities.notes.PTPLANUNTIMEDOTHER[key].UOPLNO === plno)
        .sort((a, b) => state.entities.notes.PTPLANUNTIMEDOTHER[a].UONO - state.entities.notes.PTPLANUNTIMEDOTHER[b].UONO)
        .map(key => state.entities.notes.PTPLANUNTIMEDOTHER[key]);
    let today = new Date();
    today.setHours(0, 0, 0, 0);

    let pocKey = Object.keys(state.entities.pocs)
        .find(key => state.entities.pocs[key].epno === epno &&
            new Date(state.entities.pocs[key].startDate).getTime() <= today.getTime() &&
            new Date(state.entities.pocs[key].endDate).getTime() >= today.getTime());

    let poc = undefined;

    if (pocKey !== undefined) {
        poc = state.entities.pocs[pocKey];
    } else {
        let pocs = Object.keys(state.entities.pocs)
            .filter(key => state.entities.pocs[key].epno === epno &&
                new Date(state.entities.pocs[key].endDate).getTime() < today.getTime())
            .sort((a, b) => new Date(state.entities.pocs[b].startDate).getTime() - new Date(state.entities.pocs[a].startDate).getTime())
            .map(key => state.entities.pocs[key]);
        if (pocs.length > 0) {
            poc = pocs[0];
        }
    }

    let requireNewPoc = poc === undefined || poc.status === 3 ? true : false;

    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));
    let therActPerformed = plan.PLTHERACT === true && state.entities.notes.MLTHERACT &&
        Object.keys(state.entities.notes.MLTHERACT)
            .filter(key => state.entities.notes.MLTHERACT[key].XLTAXLNO === xlno &&
                state.entities.notes.MLTHERACT[key].XLTAPERFORMED === true).length > 0 ? true : false;
    let selfCarePerformed = plan.PLSELFCARE === true && state.entities.notes.MLSELFCARE &&
        Object.keys(state.entities.notes.MLSELFCARE)
            .filter(key => state.entities.notes.MLSELFCARE[key].XLSCXLNO === xlno &&
                state.entities.notes.MLSELFCARE[key].XLSCPERFORMED === true).length > 0 ? true : false;
    let neuroPerformed = plan.PLNEURO === true && state.entities.notes.MLNEURO &&
        Object.keys(state.entities.notes.MLNEURO)
            .filter(key => state.entities.notes.MLNEURO[key].XLNEXLNO === xlno &&
                state.entities.notes.MLNEURO[key].XLNEPERFORMED === true).length > 0 ? true : false;
    let therExPerformed = plan.PLTHEREX === true && state.entities.notes.MLTHEREX &&
        Object.keys(state.entities.notes.MLTHEREX)
            .filter(key => state.entities.notes.MLTHEREX[key].XLTEXLNO === xlno &&
                state.entities.notes.MLTHEREX[key].XLTEPERFORMED === true).length > 0 ? true : false;
    let manualPerformed = plan.PLMANUAL === true && state.entities.notes.MLMANUAL &&
        Object.keys(state.entities.notes.MLMANUAL)
            .filter(key => state.entities.notes.MLMANUAL[key].XLMAXLNO === xlno &&
                state.entities.notes.MLMANUAL[key].XLMAPERFORMED === true).length > 0 ? true : false;
    let gaitPerformed = plan.PLGAIT === true && state.entities.notes.MLGAIT &&
        Object.keys(state.entities.notes.MLGAIT)
            .filter(key => state.entities.notes.MLGAIT[key].XLGAXLNO === xlno &&
                state.entities.notes.MLGAIT[key].XLGAPERFORMED === true).length > 0 ? true : false;
    let aquaPerformed = plan.PLAQUATICS === true && state.entities.notes.MLAQUATICS &&
        Object.keys(state.entities.notes.MLAQUATICS)
            .filter(key => state.entities.notes.MLAQUATICS[key].XLAQXLNO === xlno &&
                state.entities.notes.MLAQUATICS[key].XLAQPERFORMED === true).length > 0 ? true : false;
    let physTestPerformed = plan.PLPERFTEST === true && state.entities.notes.MLSPECIALTYTESTS &&
        Object.keys(state.entities.notes.MLSPECIALTYTESTS)
            .filter(key => state.entities.notes.MLSPECIALTYTESTS[key].XLSZXLNO === xlno &&
                state.entities.notes.MLSPECIALTYTESTS[key].XLSZPERFORMED === true).length > 0 ? true : false;

    let rangeUsed = plan.PLPOCTIMESMIN || plan.PLPOCDURMIN ? true : false;

    let rtmAvailable = state.entities.admissions[epno].rtm98975Billable ||
        state.entities.admissions[epno].rtm98977Billable ||
        state.entities.admissions[epno].rtm98980Billable ||
        state.entities.admissions[epno].rtm98981Billable ||
        state.entities.admissions[epno].rtm98985Billable ||
        state.entities.admissions[epno].rtm98979Billable;


    let isPeds = state.entities.admissions[epno].isPeds;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_PEDS_ENABLED'].PRVALUE === 'true' : false;
    if (!isPedsEnabled) {
        isPeds = false;
    }

    let isMinEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PEDS_MIN_PER_SESSION_ENABLED'].PRVALUE === 'true' : false;

    let isSpeechEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_SPEECH_ENABLED'].PRVALUE === 'true' : false;
    let isSpeech = state.entities.admissions[epno].discipline === "ST" && isSpeechEnabled;

    let speechSelectedOptions = Object.keys(state.entities.notes.MLSPEECH)
        .filter(key => {
            return (state.entities.notes.MLSPEECH[key].XLSPXLNO === xlno)
        })
        .sort((a, b) => state.entities.notes.MLSPEECH[a].XLSPNO - state.entities.notes.MLSPEECH[b].XLSPNO)
        .map(key => state.entities.notes.MLSPEECH[key].XLSPSPNO);

    return {
        noteId,
        noteType,
        isWc: state.entities.admissions[epno].isWc,
        plno,
        plan,
        poc,
        timedModalities,
        untimedModalities,
        untimedOther,
        therActPerformed,
        selfCarePerformed,
        neuroPerformed,
        therExPerformed,
        manualPerformed,
        gaitPerformed,
        aquaPerformed,
        physTestPerformed,
        rangeUsed,
        requireNewPoc,
        rtmAvailable,
        isPeds,
        isSpeech,
        speechSelectedOptions,
        isMinEnabled
    };
}

const connectedPatientCareCenterNotePlanBody = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNotePlanBody);
export { connectedPatientCareCenterNotePlanBody as PatientCareCenterNotePlanBody };

